export default "__VITE_ASSET__Ba23MRB$__"